import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const DEFAULT_CATEGORIES = [
  "Family",
  "Health",
  "Work",
  "Gratitude",
  "Guidance",
  "Friends",
  "Community",
  "Personal",
];

export function formatPrayerForShare(p) {
  const lines = [`Prayer Request: ${p.title}`];
  if (p.for_whom) lines.push(`For: ${p.for_whom}`);
  if (p.details) lines.push("", p.details);
  if (p.categories?.length) lines.push("", `Categories: ${p.categories.join(", ")}`);
  return lines.join("\n");
}

export function formatDate(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
  } catch {
    return "";
  }
}
